const nav = {
    items: [
        {
            name: 'Dashboard',
            url: 'Dashboard',
        },
        {
            name: 'Stores',
            url: '',
            children: [
                {
                    name: 'Management stores',
                    url: 'Stores',
                },
                {
                    name: 'POS',
                    url: 'POS ',
                },
                {
                    name: 'Devices',
                    url: 'Devices',
                    badge: {
                        text: '',
                        variant: 'danger'
                    },
                    allowedFor: ['mkt_it'],
                    hiddenFor: ['mkt_unknown']
                },
            ]
        },
        {
            name: 'Price List',
            url: 'PricelistContainer',
            icon: 'icon-book-open',
            allowedFor: ['feat_provisioning'],
        },
        {
            name: 'Documents',
            url: 'Documents',
            children: [
                {
                    name: 'Invoices and Documents',
                    url: 'Documents',
                },
                {
                    name: 'Proformas',
                    url: 'Proformas',
                    allowedFor: ['mkt_it'],
                    hiddenFor: ['mkt_unknown'],
                },
                {
                    name: 'Daily Closures',
                    url: 'Closures'
                },
                {
                    name: 'CashFlow',
                    url: 'CashFlow',
                    allowedFor: ['mkt_it'],
                    hiddenFor: ['mkt_unknown'],
                    disabledForLicenseCode: ['personal']
                },
            ]
        },
        {
            name: 'Guests',
            url: 'Guests',
            allowedFor: ['mkt_it', 'mkt_de', 'with_guests'],
            hiddenFor: ['mkt_unknown'],
        },
        {
          name: 'PrintStatistics',
          url: 'PrintStatistics',
          disabledForLicenseCode: ['personal']
        }

    ],
    side_items: [
        {
            name: 'Company Data',
            url: 'Company Data',
            icon: 'fas fa-building'
        },
        {
            name: 'Pos settings',
            url: 'Pos Settings',
            icon: 'fas fa-cash-register',
            allowedFor: ['feat_provisioning'],
        },
        {
            name: 'Services',
            url: 'Services',
            icon: 'fas fa-puzzle-piece',
            allowedFor: ['mkt_it'],
            hiddenFor: ['mkt_unknown']
        },
        {
            name: 'Settings',
            url: 'Settings',
            icon: 'fas fa-cog',
            allowedFor: ['mkt_it'],
            hiddenFor: ['mkt_unknown']
        },
    ]
}

export default nav;
